import $ from 'jquery';
import plugin from '@core/plugins/lib';
import { onAvailable } from "@core/plugins/lib/selectors";

export const ELEMENT_SELECTOR = '[data-trigger-event]';
export const PLUGIN_NAME = 'triggerEvent';


$(() => {
	onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		System.import(
			/* webpackChunkName: "plugin--trigger-event" */ './plugin.js'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__trigger-event/index.js